export const BM_CREATE = 'bmCreate'
export const BM_EDIT = 'bmEdit'
export const BM_DELETE = 'bmDelete'
export const BM_GET = 'bmGet'
export const BMS_GET = 'bmsGet'
export const BM_DAYS_OFF_GET = 'bmDaysOffGet'